module.exports = __webpack_public_path__ + "img/flying.8c1e094f.svg";